
import React from 'react';
import { Dialog, DialogContent } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';

interface EmojiReactionPickerProps {
  isOpen: boolean;
  onClose: () => void;
  onSelectEmoji: (emoji: string) => void;
}

export const EmojiReactionPicker: React.FC<EmojiReactionPickerProps> = ({
  isOpen,
  onClose,
  onSelectEmoji
}) => {
  // Common emojis used in chat applications
  const commonEmojis = ['👍', '❤️', '😂', '😮', '😢', '👏', '🎉', '🙏'];
  
  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="p-2 w-auto max-w-[280px]">
        <div className="flex flex-wrap justify-center gap-2">
          {commonEmojis.map(emoji => (
            <Button
              key={emoji}
              variant="ghost"
              className="h-12 w-12 text-2xl hover:bg-accent"
              onClick={() => onSelectEmoji(emoji)}
            >
              {emoji}
            </Button>
          ))}
        </div>
      </DialogContent>
    </Dialog>
  );
};
